// extracted by mini-css-extract-plugin
module.exports = {"tabs":"PageTabs_tabs__1M6lO","tabsItem":"PageTabs_tabsItem__3p9NM","withClick":"PageTabs_withClick__2diz7","active":"PageTabs_active__tCWUu"};